const verificarParentescoPrenchido = parentesco => parentesco !== '';
const idadeAte64 = idade => idade <= 64;
const idadeAte65 = idade => idade >= 65;

export const validatorPossui2Dependentes65anos = (dependentes,valoresForm) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        calcularQuantidadeDependentes65anos(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const calcularQuantidadeDependentes65anos = (dependentes => {
    const qtdDependentes =  dependentes.filter(dep => dep.Idade >= 65).length;

    return qtdDependentes === 2 ? true : false;
});

export const validatorPossui2DependentesAte64anos = (dependentes,valoresForm) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        calcularQuantidadeDependentesAte64anos(dependentes),
        validatorParentescoDependenteE1Ate64(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const calcularQuantidadeDependentesAte64anos = (dependentes => {
    const qtdDependentes =  dependentes.filter(dep => dep.Idade < 65).length;

    return qtdDependentes === 2 ? true : false;
});

const parentescosPermitidosZeloCombateE1 = [
    '01', '02', '5', '10006', '12', '10', '19', '20'
];

const parentescosPermitidosZeloCombateE2 = [
    '03','07', '10016', '15', '22', '24', 'AVô', '01', '02', '5', '10006', '12', '10', '19', '20'
];

const parentescosPermitidosZeloE1Ate64 = [
    '03','07', '10016', '15', '22', '24', 'AVô'
];

export const validatorParentescoDependenteE1 = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescoPermitido(valoresForm.Parentesco.trim()),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarParentescoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidosZeloCombateE1.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

export const validatorParentescoDependenteE2 = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescoPermitidoE2(valoresForm.Parentesco.trim()),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarParentescoPermitidoE2 = parentesco => {
    const parentescoEncontrado = parentescosPermitidosZeloCombateE2.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

export const validatorParentescoDependenteE1Ate64 = valoresForm => {
    const arrayDeValidacoes = [
        !verificarParentescoPermitidoE1Ate64(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarParentescoPermitidoE1Ate64 = parentesco => {
    const parentescoEncontrado = parentescosPermitidosZeloE1Ate64.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

export const getParentescoByValue = value => {
    const parentescos = [
        {
            value: '01   ',
            label: 'PAI'
        },
        {
            value: '20008   ',
            label: 'PADRASTO'
        },
        {
            value: '02   ',
            label: 'MAE'
        },
        {
            value: '20007   ',
            label: 'MADRASTA'
        },
        {
            'value': '03   ',
            'label': 'IRMA(O)'
        },
        {
            'value': '07   ',
            'label': 'SOBRINHO(A)'
        },
        {
            'value': '10   ',
            'label': 'ESPOSO(A)'
        },
        {
            value: '32   ',
            label: 'EX-CONJUGE'
        },
        {
            'value': '10006',
            'label': 'ENTEADO(A)'
        },
        {
            'value': '10016',
            'label': 'OUTROS'
        },
        {
            'value': '12   ',
            'label': 'NETO(A)'
        },
        {
            'value': '15   ',
            'label': 'SOGRO(A)'
        },
        {
            'value': '22   ',
            'label': 'PRIMO(A)'
        },
        {
            value: '19   ',
            label: 'GENRO'
        },
        {
            value: '20   ',
            label: 'NORA'
        },
        {
            'value': '24   ',
            'label': 'TIO(A)'
        },
        {
            'value': '5    ',
            'label': 'FILHO(A)'
        },
        {
            value: '50    ',
            label: 'FILHO(A) ADOTIVO'
        },
        {
            'value': 'AVô  ',
            'label': 'AVO'
        },
        {
            'value': 'PET  ',
            'label': 'PET (ANIMAL)'
        }
    ];

    return parentescos.find(parentesco => parentesco.value.trim() === value);
};
